<app-preloader *ngIf="clientsService.isLoading()"></app-preloader>
<div class="modal">
  <a class="close" (click)="close()">Cerrar</a>
  <h1>Seleccionar cliente</h1>

  <div class="seleccionarCliente">
    <form>
      <div class="filters">
        <ng-container>
          <div class="wrapper">
            <div class="controlWrapper">
              <label>Nombre</label>
              <!-- INCLUIR IMPUT -->
              <app-input [data]="nameValue" (textSearch)="filter($event, 'name')" [resetInput]="isResetNameFilter()">
              </app-input>
            </div>
            <div class="controlWrapper">
              <label>RFC</label>
              <app-input [data]="rfcValue" (textSearch)="filter($event, 'rfc')" [resetInput]="isResetRfcFilter()">
              </app-input>
            </div>

            <div class="controlWrapper">
              <label>Tipo de persona</label>
              <app-select
                [options]="clientsService.personTypeOptions"
                placeholder="Tipo de persona"
                [resetSelect]="isResetTypeFilter()"
                (optionSelected)="filter($event, 'type')"
              ></app-select>
            </div>

            <div class="filtersActions">
              <button class="secondary clear" tp="Limpiar filtros" (click)="resetFilters()" [disabled]="isEmptyQuerys">
                Limpiar filtros
              </button>
              <button class="primary search" tp="Buscar" (click)="applyFilters()">Buscar</button>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="customTable seleccionarCliente">
        <div class="header">
          <div class="cell nombre">Nombre</div>
          <div class="cell rfc">RFC</div>
          <div class="cell tipo">Tipo de persona</div>
        </div>
        <div class="rowsWrapper" #scrollContainer>
          @for (client of clientsService.clientList(); track client.id) {
          <div class="row" (click)="selectClient(client)" [class.selected]="client.id === selectedRow()?.id">
            <div class="cell nombre">{{ clientsService.getCustomerName(client) }}</div>
            <div class="cell rfc">{{ client.rfc }}</div>
            <div class="cell tipo">{{ clientsService.getPersonType(client.personType) }}</div>
          </div>
          } @empty { @if (!clientsService.isLoading()) { No hay clientes } } @if(clientsService.isLoadingMore()){
          <div class="row">
            <div class="cell loading">
              <div class="spinner"></div>
              Cargando...
            </div>
          </div>
          }
        </div>
      </div>
      <div class="itemsInfo">{{ clientRows }} ítems</div>
      <!-- Acciones para modal condición -->
      <div class="actions">
        <div class="wrapper">
          <button type="submit" class="primary" [disabled]="!isSelectedClient" (click)="selectAndClose()">
            Seleccionar
          </button>
          <button type="button" class="secondary" (click)="goToNewClient()">Nuevo cliente</button>
          <button (click)="close()" type="button" class="secondary">Cancelar</button>
        </div>
      </div>
    </form>
  </div>
</div>
